export default {
  validationError: {
    allowedMinTooLarge: 'min > max',
    allowedMaxTooSmall: 'max < min',
    defaultValueExceedAllowed: 'Standardwert liegt außerhalb des erlaubten Wertebereichs.',
  },
};
